<template>
  <section>
    <div class="container wfs--main">
      <div class="row">
        <div class="col-md-12 bread">
          <ol class="bread-crumb breadcrumb-fill0">
              <li><router-link to="/home">home</router-link></li>
              <li><a href="javascript:void(0);" class="bread-text ">Login</a></li>
          </ol>
        </div>
        <div class="col-md-12" v-if="resposta" style="padding:0px!important">
            <div class="card" style="margin-top:20px;background-color: rgb(187 93 78) !important;color: #fff !important;" >
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12" >
                      {{resposta}}
                  </div>
                </div>
                
              </div>  
            </div> 
        </div>
        <!--Login do cidadao-->
        <div class="col-md-12" >
          <div class="row">
            <div class="col-md-6" >
              <h4 slot="header" class="card-title">Login Cidadão</h4>
              <form>
                  <input  type="email" placeholder="Email" v-model="email" required="required" autofocus="autofocus" class="form-control">
                  <input  type="password" placeholder="Senha" v-model="senha" required="required" class="form-control" style="margin-top: 15px;margin-bottom: 15px;">
                  <!--Recaptcha-->
                  <g-recaptcha :sitekey='sitekey' :callback="callback" style="margin-bottom: 10px;" ></g-recaptcha> 

                  <div class="col-md-12" style="margin-bottom:20px;">
                      <a type="submit" class="" @click.prevent="cidadaoNovoCadastro" style="margin-left:-5px;color: #258aff;">  
                        Registrar-se
                      </a>
                      <a type="button" class="" @click.prevent="esquecieSenha" style="margin-left:30px;color: #258aff;">  
                        Esqueceu a senha?
                      </a>
                  </div>
                  <div class="text-center">
                      <button type="submit" class="btn btn-primary btn-fill float-left" @click.prevent="cidadaoLogar">  
                        Entrar
                      </button>
                    
                  </div>
                  <div class="clearfix"></div>
              </form>
              
            </div>
            <div class="col-md-6">
                <img src="/img/ilust-logar.jpg" style="width:100%">
            </div>
          </div>
        </div>
          
      </div>
    </div>
  </section>  
</template>
<script>
  import Card from 'src/components/Cards/Card.vue'
  import axios from 'axios';
  import store from "src/store.js"
  import 'src/controller/site/manifestacaoController.js'
  import 'src/controller/site/homeController.js'
  import gRecaptcha from 'src/components/recaptcha.vue'

  export default {
    name: 'loginCidadao',
    metaInfo: {
      htmlAttrs: {
        lang: 'pt-BR',
      },
      title: 'Login Cidadão',
      meta: [
        { name: 'descrition', content: 'Pagina de Login do Cidadão na Ouvidoria da Prefeitura Municipal de São José de Ubá.' },
        {property: 'og:title', content: 'Login Cidadão'},
        {property: 'og:image', content: '/img/logo-topo.png'},
      ],
      
    },
    components: {
      Card,
      gRecaptcha
    }, 
    props: {
      msg_prop: null,
    },
    data () {
      return {
        email:null,
        senha:null,
        resposta:null,
        sitekey: '6LckQ44UAAAAACWBb_BCpXSXDRVQWnVN72JmWsPE',
        token: null,
      }
    },
    methods: {
      callback(token){
        this.token = token;
      },
      async cidadaoLogar(){
        try {
          let data = await this.$LoginCidadao(this.email,this.senha,this.token);
          this.email = null;
          this.senha = null;
          this.token = null;
          if(data){
            if(data.response.data){
               this.resposta= data.response.data;
               //grecaptcha.reset();
            }
            if(data.response.data.error){
               this.resposta="Nome de usuário ou senha invalidos. Por favor tente outra vez!";
               grecaptcha.reset();
            }
          }else{
            this.token = sessionStorage.getItem("token");
            store.user = this.token;
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem("token");
            this.$router.push({name: 'painelcidadao'} );
          }
        } catch (e) {
          throw e;
        }
      },
      
      cidadaoNovoCadastro(){
        this.$router.push({name: 'registroCidadao'} );
      },

      esquecieSenha(){
        this.$router.push({name: 'loginesqueceusenha'} );
      },
     
     
    },
    beforeMount(){
      console.log(this.msg_prop)
    }
    
  }

</script>
<style>
    ol {
        list-style: none;
    }
    .bread{
      padding-right: 0px;
      padding-left: 0px;
    }
    .bread-crumb {
        width: 100%;
        float: left;
        margin: 0px 0px 20px 0;
        position: relative;
        display: block;
        margin-top: 8px;
        font-size: 12px;
        font-weight: 700;
        text-transform: uppercase;
    }
    .breadcrumb-fill0 {
        padding: 10px;
        background: #ffffff;
        border-radius: 5px;
        box-shadow: 0 0 40px -10px rgba(0, 0, 0, 0.25);
    }
    .bread-crumb li {
        height: auto;
        line-height: 30px;
        float: left;
        padding: 0 12px;
    }
    .bread-text,.bread-text:hover{
      color:black;
    }
</style>
